import React from 'react';
import { Reveal } from '../Reveal';
const STRENGTHS = ['Sabés enseñar.', 'Sabés bailar.', 'Sabés acompañar a tus alumnas.'];
export function ProductIntro() {
  return;
}